import CustomTextField from "../../../../../../../../components/customTextField/CustomTextField";
import FormButton from "../../../../../../../../components/formButton/FormButton";
import {useDispatch} from 'react-redux'
import "./LiquidityFormStyle.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import ResponseHandler from "../../../../../../../../services/ResponseHandler";
import { useEffect, useState } from "react";
import { CreateLiquidity, UpdateLiquidity } from "../../../../../../../../api/apiServices/liquidityApi";


function LiquidityForm({onClose,existingvalue}) {
    const dispatch=useDispatch()
  const [loading,setLoading]=useState(false)
  useEffect(()=>{
      if(existingvalue){
        formik.setValues({
          ...formik.values,['liquid']:existingvalue.liquidity_name
        });
      }
  },[existingvalue])
  const formik = useFormik({
    initialValues: {
        liquid: "",
    },
    validationSchema: Yup.object({
        liquid: Yup.string().required("Liquidity name is required"),
    }),
    onSubmit: (values) => {
      if(!existingvalue){
        setLoading(true)
        dispatch(CreateLiquidity(values)).then((response)=>{
          ResponseHandler(response)
          onClose(false)
        }).catch((error)=>{
          ResponseHandler(error)
        }).finally(()=>{
          setLoading(false)
        })
      }else{
        setLoading(true)
        dispatch(UpdateLiquidity(existingvalue.id,values)).then((response)=>{
          ResponseHandler(response)
          onClose(false)
        }).catch((error)=>{
          ResponseHandler(error)
        }).finally(()=>{
          setLoading(false)
        })
      }
    },
  });
  return (
    <div className="LiquidityForm_mainContainer">
    <form onSubmit={formik.handleSubmit}>
      <p className="LiquidityForm_field_title">Liquidity name</p>
      <CustomTextField
        placeholder={"Enter liquidity name"}
        name="liquid"
        autoComplete="off"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.liquid}
        error={formik.touched.liquid && Boolean(formik.errors.liquid)}
        helperText={formik.touched.liquid && formik.errors.liquid}
      />
      <div className="LiquidityForm_form_action">
        <FormButton
          type="submit"
          variant="contained"
          loading={loading}
          text={existingvalue?"Update":"Add"}
        />
        <FormButton variant="outlined" loading={false} text="Cancel" onClick={()=>{onClose(false)}} />
      </div>
    </form>
  </div>
  )
}

export default LiquidityForm